import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "./client";
import type { Role } from "@cura-studio/shared";

export type MeApi = {
  user: {
    id: string;
    email: string;
    name: string;
    role: Role;
    tenantId: string;
  } | null;
  tenant: { id: string; name: string; slug: string; status: string } | null;
};

// useMe — who am I, what tenant. Returns null on 401/403 instead of throwing,
// so the AppShell can decide whether to show the sign-in prompt.
export function useMe() {
  return useQuery<MeApi>({
    queryKey: ["me"],
    queryFn: async () => {
      try {
        return await api<MeApi>("/api/v1/me");
      } catch (err) {
        if (err instanceof ApiError && (err.status === 401 || err.status === 403)) {
          return { user: null, tenant: null };
        }
        throw err;
      }
    },
    // Soft caching — the identity rarely changes
    staleTime: 60_000,
  });
}
